<template>
	<div>
		<div>
			<!-- <button class="drawer-button" @click.stop="toggleDrawer">☰</button> -->
			<div class="drawer-content">
				<!-- 2024-1-31去掉导航，把首页加入栏目 -->
				<!-- <div class="cdcss">
					<div class="paddingcss">
						<div class="navMoblie"><span>教育版导航</span></div>
						<div class="all_menu">
							<a href="/">首页</a>
							<a
								href="http://report.drcnet.com.cn/"
								class="navtxt"
								target="_blank"
								>研究报告库</a
							>
							<a
								href="/specialTopic?uid=A201A3"
								:class="
									activeName == 'specialTopic' ||
									activeName == 'hotContent'
										? 'navtxt on'
										: 'navtxt'
								"
								>专题文献库</a
							>

							<a
								href="http://data.drcnet.com.cn/"
								class="navtxt"
								target="_blank"
								>统计数据库</a
							>
							<a
								href="http://expert.drcnet.com.cn/"
								class="navtxt"
								target="_blank"
								>专家库</a
							>
							<a
								href="http://misc.drcnet.com.cn/Personalized/PersonalizedService.aspx"
								class="navtxt"
								target="_blank"
								>个性化服务</a
							>

							<a
								href="http://misc.drcnet.com.cn/DRCNet.Users.Web/Author/authorMain.aspx"
								class="navtxt"
								target="_blank"
								>作者专区</a
							>
							<a
								href="http://misc.drcnet.com.cn/Journal/Default.aspx"
								class="navtxt"
								target="_blank"
								>期刊专区</a
							>
							<a
								href="/about"
								:class="
									activeName == 'about'
										? 'navtxt on'
										: 'navtxt'
								"
								>产品介绍</a
							>
							<a
								href="https://www.drcnet.com.cn/eDRCNet.Order.Web/Order/User/UserMain.aspx"
								class="navtxt"
								target="_blank"
								>会员专区</a
							>
							<a
								href="http://misc.drcnet.com.cn/help/index.aspx"
								class="navtxt"
								>使用帮助</a
							>
						</div>
					</div>
				</div> -->
				<div class="cdcss">
					<div class="paddingcss">
						<div class="navMoblie"><span>栏目导航</span></div>
						<ul class="one_menu">
							<li>
								<div>
									<ul class="two_menu">
										<li
											v-for="(item, index) in navList"
											:key="index"
										>
											<a
												:href="
													item == '首页'
														? '/'
														: '/baogao?attr=' + item
												"
												>{{ item }}</a
											>
										</li>
									</ul>

									<div class="clear"></div>
								</div>
							</li>
							<li>
								<div>
									<ul class="two_menu">
										<li
											v-for="(
												item, index
											) in leftSubNavList"
											:key="index"
										>
											<a
												v-if="item.isnav"
												@click="gotoLink(item)"
												:href="
													'/hylist?uid=' + item.uid
												"
												>{{ item.text }}</a
											>
										</li>
									</ul>
								</div>
							</li>
						</ul>
					</div>
					<div class="paddingcss">
						<div class="navMoblie"><span>重点专题</span></div>
						<ul class="one_menu">
							<li>
								<div>
									<ul class="two_menu">
										<li
											v-for="(
												item, index
											) in rightSubNavList"
											:key="index"
										>
											<a
												v-if="item.isnav"
												@click="gotoLink(item)"
												:href="
													'/specialTopic?uid=' +
													item.uid
												"
												>{{ item.text }}</a
											>
										</li>
									</ul>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { getNav } from '../../api/home';
import { Popup, Cell, CellGroup, Collapse, CollapseItem, Divider } from 'vant';
export default {
	name: 'homeNav',
	components: {
		Popup,
		Cell,
		CellGroup,
		Collapse,
		CollapseItem,
		Divider,
	},
	mixins: [],
	props: {},
	data() {
		return {
			activeName: this.$route.name,
			leftSubNavList: [],
			rightSubNavList: [],
			isMoblie: false,
			tableData: [],
			navList: ['首页', '资讯', '论文', '报告', '案例', '政策', '数据'],
		};
	},
	computed: {},
	watch: {
		MobileVerification: {
			handler(to) {
				// console.log(to);
				this.isMoblie = this.MobileVerification;
				// this.isMobileVt();
				// this.isMobileValue();
			},
			immediate: true,
		},
	},
	mounted() {
		this.activeName = this.$route.name;
		this.getNavs();
	},
	methods: {
		// const data = getNav({ version: 'A2' });
		getNavs() {
			// const data = getNav({ version: 'A2' });
			getNav({ version: '96' }).then((res) => {
				console.log(res);
				debugger;
				for (let index = 0; index < res.data.data.length; index++) {
					const element = res.data.data[index];
					// console.log(element);
					if (element.isnav && element.uid != '9611') {
						this.leftSubNavList.push(element);
					}
				}

				// localStorage.removeItem('leftNavList');
				// localStorage.setItem(
				// 	'leftNavList',
				// 	JSON.stringify(res.data.data)
				// );
				for (let index = 0; index < res.data.data.length; index++) {
					const element = res.data.data[index];
					// console.log(element);
					if (element.uid == '9611') {
						this.rightSubNavList = element.children;
					}
				}
				// console.log(this.leftNavList);
				// console.log(res);
			});
		},

		activeNav(name) {
			if (name == '首页' && this.activeName == 'home') {
				return 'navtxt on';
			} else if (
				name == '专题文献库' &&
				this.activeName == 'specialTopic'
			) {
				return 'navtxt on';
			} else {
				return 'navtxt';
			}
		},
		gotoLink(item) {
			if (item.uid == 'A201A2') {
				window.open('https://drcresearch.drcnet.com.cn/#/', '_blank');
				console.log(item.uid);
			} else if (item.uid == 'A201AA') {
				window.open(
					'https://www.drcnet.com.cn/specialSubject?listShow=A1020402',
					'_blank',
				);
			} else if (item.uid == 'A201A4') {
				window.open('https://www.drcnet.com.cn/finance/#/', '_blank');
			} else if (item.uid == '000') {
				this.$router.push('/');
			} else {
				if (this.$route.path == '/') {
					this.$router.push({
						path: '/specialTopic',
						query: { uid: item.uid },
					});
				} else {
					this.$eventBus.$emit('upLists', item.uid);
				}
			}
			this.$eventBus.$emit('isDrawer', false);
			// this.isDrawerOpen = false;
		},
		//打开抽屉
		// toggleDrawer() {
		// 	this.isDrawerOpen = !this.isDrawerOpen;
		// },
	},
};
</script>
<style lang="less" scoped>
@media screen and (max-width: 769px) {
	.nav {
		width: 0 !important;
	}
}

.nav {
	width: 100%;
	min-width: 1400px;
	height: 45px;
	display: flex;
	line-height: 45px;
	background: #015293 url('../../assets/homeImage/navbj.jpg') repeat-x;
}

.nobackground {
}

.homeNavs {
	width: 1400px;
	max-width: 1400px;
	margin: 0 auto;
}

.nav .homeNavs .ul1 li {
	float: left;
}

.nav .homeNavs .ul1 li a {
	color: #fff;
	padding-right: 57px;
	font-size: 17px;
}

.nav .homeNavs .ul2 li {
	float: left;
}

.nav .homeNavs .ul2 li a {
	color: #fff;
	padding-right: 26px;
	font-size: 14px;
}

.nav .homeNavs li a:hover,
.nav .homeNavs li a.on {
	color: #ffe400;
}
</style>
<!-- 手机端样式 -->
<style scoped lang="less">
.drawer-button {
	position: fixed;
	top: 20px;
	left: 20px;
	background: transparent;
	border: none;
	cursor: pointer;
	font-size: 24px;
	z-index: 100;
	/* 更高的层级 */
}

.cdcss {
	// margin: 10px 0;
	background: #fff;
	position: relative;

	.paddingcss {
		padding: 0 10px;
		display: flex;
		flex-direction: column;
	}

	.navMoblie {
		border-bottom: 1px solid #ececec;
		position: relative;
		padding: 10px 10px 0 10px;

		span {
			font-size: 18px;
			color: #1a1a1a;
			height: 35px;
			line-height: 35px;
			position: relative;
			display: block;
		}
	}

	.all_menu {
		width: 100%;
		font-size: 16px;
		white-space: nowrap;
		overflow: auto;
		padding: 10px 0;

		a {
			color: #474747;
			padding-left: 15px;
			padding-right: 15px;
			border-right: 1px solid #eaeaea;
			text-decoration: none;
		}

		a:nth-child(1) {
			padding-left: 0px;
		}

		a:link,
		a:visited,
		a:active {
			color: #363636;
			text-decoration: none;
			cursor: pointer;
		}
	}

	.one_menu {
		padding: 10px;

		.acss {
			font-size: 20px;
			color: #474747;
			margin: 15px 0;
			display: block;
			background: url(../../assets/special/conlefticon.jpg) no-repeat left
				3px;
			height: 15px;
			padding-left: 16px;
		}

		.two_menu {
			a {
				font-size: 12px;
				color: #474747;
				display: block;
				float: left;
				padding: 6px 8px;
				border: 1px solid #f1f1f1;
				border-radius: 20px;
				margin: 5px;
			}
		}

		a:link,
		a:visited,
		a:active {
			color: #363636;
			text-decoration: none;
			cursor: pointer;
		}
	}
}
</style>
